import React from 'react'

const Button = ({className ,onClick ,disabled ,label ,isLoading ,type="button"}) => {
  return (
    <button type={type} className={`position-relative btn w-100 font14 font600  ${isLoading ?"loader":""} ${className}`} disabled={disabled}  onClick={onClick}> <span className='font600'>{label}</span> </button>
  )
}

export default Button